import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import axios from 'axios'
import './validate'
import './sweetalert2'
import { i18n } from './i18n'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.min.css'
import 'bootstrap'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
import moment from 'moment'
Vue.prototype.moment = moment

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
Vue.use(PaperDashboard);

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

const token = localStorage.getItem('token')
if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

Vue.config.productionTip = false
new Vue({
    router,
    store,
    i18n,
    created: function () {
        axios.interceptors.response.use(undefined, function (err) {
            if (err.response.status === 401) {
                store.dispatch('interceptToken')
            }else {
                return Promise.reject(err);
            }
        });
    },
    render: h => h(App)
}).$mount('#app')
